exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.bargain-task .user-info img {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\n}\n.bargain-task .product-pic {\r\n  width: 30px;\r\n  height: 30px;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/plus/bargain/task/index.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;CACpB;AACD;EACE,YAAY;EACZ,aAAa;CACd","file":"index.vue","sourcesContent":["\n.bargain-task .user-info img {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\n}\n.bargain-task .product-pic {\r\n  width: 30px;\r\n  height: 30px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-273f8fee","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/plus/bargain/task/index.vue
// module id = nqjQ
// module chunks = 0